import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import * as dropdownsActions from "../../../../actions/dropdowns.actions";
import * as projectActions from "../../../../actions/project.actions";

import ProjectBudget from "../components/ProjectBudget";

const steps = projectId => [
  {
    caption: "Basics",
    url: `/company/project/id/${projectId}/basics`
  },
  {
    caption: "Details",
    url: `/company/project/id/${projectId}/details`
  },
  {
    caption: "Skills",
    url: `/company/project/id/${projectId}/skills`
  },
  {
    caption: "Budget",
    url: `/company/project/id/${projectId}/budget`
  },
  {
    caption: "Review",
    url: `/company/project/id/${projectId}/review`
  }
];

class ProjectBudgetContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.dropdownsActions.getProjectBudgetRateTypes();
  }

  handleSubmit(data) {
    const adminEdit = false;
    const loading = true;

    // Track Mixpanel event
    Mixpanel.track("Project Creation - Budget - Save + Continue");

    this.props.projectActions.updateProject(
      data,
      "review",
      this.props.match.params.projectId,
      adminEdit,
      loading
    );
  }

  render() {
    return this.props.project ? (
      <ProjectBudget
        project={this.props.project}
        projectBudgetRateTypes={this.props.projectBudgetRateTypes}
        steps={steps(this.props.match.params.projectId)}
        onSubmit={this.handleSubmit}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    project: state.project.data.data,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data
  };
};

const mapDispatchToProps = dispatch => ({
  dropdownsActions: bindActionCreators(dropdownsActions, dispatch),
  projectActions: bindActionCreators(projectActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectBudgetContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/project/containers/ProjectBudgetContainer.js